/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountProvisioningHistoryRequest} from '../models/AccountProvisioningHistoryRequest';
import type {AccountProvisioningHistoryResult} from '../models/AccountProvisioningHistoryResult';
import type {DailyUserCountByType} from '../models/DailyUserCountByType';
import type {Error} from '../models/Error';

export interface GetAccountProvisioningHistory$Request {
    accountId: number;
    accountProvisioningHistoryRequest: AccountProvisioningHistoryRequest;
}

export interface GetAccountProvisioningHistory$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountProvisioningHistoryRequest = createAction<PayloadData<void, GetAccountProvisioningHistory$Request>>('GET_ACCOUNT_USER_HISTORY_BY_TYPE__GET_ACCOUNT_PROVISIONING_HISTORY__REQUEST');
export const getAccountProvisioningHistorySuccess = createAction<PayloadData<AccountProvisioningHistoryResult, GetAccountProvisioningHistory$Request>>('GET_ACCOUNT_USER_HISTORY_BY_TYPE__GET_ACCOUNT_PROVISIONING_HISTORY__SUCCESS');
export const getAccountProvisioningHistoryFailure = createAction<PayloadData<Error, GetAccountProvisioningHistory$Request, true>>('GET_ACCOUNT_USER_HISTORY_BY_TYPE__GET_ACCOUNT_PROVISIONING_HISTORY__FAILURE');

export const getAccountProvisioningHistoryActions = [
    getAccountProvisioningHistoryRequest,
    getAccountProvisioningHistorySuccess,
    getAccountProvisioningHistoryFailure
] as const;

/**
 * Get filtered account provisioning history
 * @param {number} meta.accountId The unique identifier of the account
 * @param {AccountProvisioningHistoryRequest} meta.accountProvisioningHistoryRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountProvisioningHistory = (meta: GetAccountProvisioningHistory$Request, config?: GetAccountProvisioningHistory$Config) => {
    return {
        CALL_API: {
            types: getAccountProvisioningHistoryActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/${meta.accountId}/users/history/by-type`,
            TRANSPORT_REQUEST_BODY: meta.accountProvisioningHistoryRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAccountUserHistoryByType$Request {
    accountId: number;
    days?: number;
    startDate?: string;
    endDate?: string;
    groupBy?: string;
}

export interface GetAccountUserHistoryByType$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountUserHistoryByTypeRequest = createAction<PayloadData<void, GetAccountUserHistoryByType$Request>>('GET_ACCOUNT_USER_HISTORY_BY_TYPE__GET_ACCOUNT_USER_HISTORY_BY_TYPE__REQUEST');
export const getAccountUserHistoryByTypeSuccess = createAction<PayloadData<Array<DailyUserCountByType>, GetAccountUserHistoryByType$Request>>('GET_ACCOUNT_USER_HISTORY_BY_TYPE__GET_ACCOUNT_USER_HISTORY_BY_TYPE__SUCCESS');
export const getAccountUserHistoryByTypeFailure = createAction<PayloadData<Error, GetAccountUserHistoryByType$Request, true>>('GET_ACCOUNT_USER_HISTORY_BY_TYPE__GET_ACCOUNT_USER_HISTORY_BY_TYPE__FAILURE');

export const getAccountUserHistoryByTypeActions = [
    getAccountUserHistoryByTypeRequest,
    getAccountUserHistoryByTypeSuccess,
    getAccountUserHistoryByTypeFailure
] as const;

/**
 * Get seat allocation history by platform access type
 * @param {number} meta.accountId The unique identifier of the account
 * @param {number} [meta.days] Legacy daily range (10-90, defaults to 10 when no date range is provided). Cannot be combined with startDate, endDate or groupBy.
 * @param {string} [meta.startDate] Inclusive UTC start date, no earlier than today minus 3 calendar years. Requires endDate.
 * @param {string} [meta.endDate] Inclusive UTC end date, on or after startDate and no later than today. Requires startDate.
 * @param {string} [meta.groupBy] Grouping for an explicit date range, defaults to DAY. Each interval shows its end state; weeks begin on Monday.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountUserHistoryByType = (meta: GetAccountUserHistoryByType$Request, config?: GetAccountUserHistoryByType$Config) => {
    const TRANSPORT_GET_PARAMS = {
        days: meta.days,
        startDate: meta.startDate,
        endDate: meta.endDate,
        groupBy: meta.groupBy,
    };
    return {
        CALL_API: {
            types: getAccountUserHistoryByTypeActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/users/history/by-type`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

